import type Trip from './Trip';
import { type SegmentOption } from './types';

export default class TripSegment<T extends Trip = Trip> {
    trips: T[];

    options: SegmentOption[];

    compactOptions: SegmentOption[];

    stopsDescription: string;

    isOriginMismatched = false;
    isDestinationMismatched = false;

    get firstTrip(): T | undefined {
        return this.trips[0];
    }

    get lastTrip(): T | undefined {
        return this.trips[this.trips.length - 1];
    }

    get durationDays() {
        const departureNormalized = dayConfig
            .gregory(this.departureDateTime)
            .set('hours', 0)
            .set('minutes', 0)
            .set('seconds', 0);
        const arrivalNormalized = dayConfig
            .gregory(this.arrivalDateTime)
            .set('hours', 0)
            .set('minutes', 0)
            .set('seconds', 0);
        return arrivalNormalized.diff(departureNormalized, 'days');
    }

    get duration() {
        let duration = 0;
        for (let i = 0; i < this.trips.length; i++) {
            duration += this.trips[i].duration;
            if (i !== 0) {
                duration += Math.floor(
                    (this.trips[i].departureDateTime.getTime() -
                        this.trips[i - 1].arrivalDateTime.getTime()) /
                        1000
                );
            }
        }

        return duration;
    }

    get digest() {
        return this.trips;
    }

    get departureTime() {
        return this.trips[0].departureTime;
    }

    get departureDateTime() {
        return this.trips[0].departureDateTime;
    }

    get origin() {
        return this.trips[0].origin;
    }

    get arrivalTime() {
        return this.trips.at(-1)?.arrivalTime ?? '';
    }

    get arrivalDateTime() {
        return this.trips.at(-1)?.arrivalDateTime;
    }

    get destination() {
        return this.trips.at(-1)?.destination ?? '';
    }

    constructor(
        trips: T[],
        options: SegmentOption[],
        stopsDescription: string,
        public collapseTrips = true,
        compactOptions = options
    ) {
        this.trips = trips;
        this.options = options;
        this.stopsDescription = stopsDescription;
        this.compactOptions = compactOptions;
    }
}
